module.exports = __webpack_public_path__ + "static/media/prismport-3.ab9e05b5.jpg";